import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';
import Icon from '../../../components/AppIcon';

const CommissionBreakdown = () => {
  const commissionData = [
    { 
      vertical: 'Food Delivery', 
      commission: 156780, 
      percentage: 36.8, 
      color: '#2563EB',
      orders: 12450,
      avgCommission: 12.6
    },
    { 
      vertical: 'Home Services', 
      commission: 128940, 
      percentage: 30.3, 
      color: '#059669',
      orders: 8920,
      avgCommission: 14.5
    },
    { 
      vertical: 'Property', 
      commission: 89320, 
      percentage: 21.0, 
      color: '#D97706',
      orders: 2340,
      avgCommission: 38.2
    },
    { 
      vertical: 'Tours & Travel', 
      commission: 51069, 
      percentage: 11.9, 
      color: '#DC2626',
      orders: 1890,
      avgCommission: 27.0
    }
  ];

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload?.length) {
      const data = payload?.[0]?.payload;
      return (
        <div className="bg-popover border border-border rounded-lg p-3 elevation-2">
          <p className="text-sm font-medium text-foreground mb-2">{data?.vertical}</p>
          <div className="space-y-1 text-xs">
            <div className="flex justify-between">
              <span className="text-muted-foreground">Commission:</span>
              <span className="font-medium">${data?.commission?.toLocaleString()}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-muted-foreground">Orders:</span>
              <span className="font-medium">{data?.orders?.toLocaleString()}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-muted-foreground">Avg Rate:</span>
              <span className="font-medium">{data?.avgCommission}%</span>
            </div>
          </div>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 elevation-1">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-lg font-semibold text-foreground mb-1">Commission by Vertical</h3>
          <p className="text-sm text-muted-foreground">Revenue distribution across business verticals</p>
        </div>
        <Icon name="PieChart" size={20} className="text-muted-foreground" />
      </div>
      <div className="h-64 mb-6">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={commissionData}
              cx="50%"
              cy="50%"
              innerRadius={40}
              outerRadius={80}
              paddingAngle={2}
              dataKey="commission"
            >
              {commissionData?.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry?.color} />
              ))}
            </Pie>
            <Tooltip content={<CustomTooltip />} />
          </PieChart>
        </ResponsiveContainer>
      </div>
      <div className="space-y-3">
        {commissionData?.map((item, index) => (
          <div key={index} className="flex items-center justify-between p-3 bg-muted/30 rounded-lg">
            <div className="flex items-center space-x-3">
              <div 
                className="w-3 h-3 rounded-full" 
                style={{ backgroundColor: item?.color }}
              ></div>
              <div>
                <p className="text-sm font-medium text-foreground">{item?.vertical}</p>
                <p className="text-xs text-muted-foreground">{item?.orders?.toLocaleString()} orders</p>
              </div>
            </div>
            <div className="text-right">
              <p className="text-sm font-semibold text-foreground">${item?.commission?.toLocaleString()}</p>
              <p className="text-xs text-muted-foreground">{item?.percentage}%</p>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-6 pt-4 border-t border-border">
        <div className="grid grid-cols-2 gap-4 text-center">
          <div>
            <p className="text-2xl font-bold text-foreground">$426,109</p>
            <p className="text-xs text-muted-foreground">Total Commission</p>
          </div>
          <div>
            <p className="text-2xl font-bold text-foreground">14.96%</p>
            <p className="text-xs text-muted-foreground">Avg Take Rate</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommissionBreakdown;